module.exports = __webpack_public_path__ + "static/media/Scrubs-Women.5f5de5a9.png";